const formatTemplatesCount = (count: number) => {
  if (!count) return null;
  return count.toLocaleString();
};

export default formatTemplatesCount;
